module.exports = __webpack_public_path__ + "img/24.c2887eb9.jpeg";